import React from 'react'
import { SvgIcon } from '@material-ui/core'

function Clear2Icon(props) {
  return (
    <SvgIcon {...props}>
      <path
        id='Vector'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M16 12L14.8 14.796L12 15.996L14.8 17.193L16 20L17.2 17.193L20 16L17.2 14.796L16 12ZM9 4L7.5 7.5L4 8.995L7.5 10.5L9 14L10.5 10.5L14 9L10.5 7.5L9 4Z'
      />
    </SvgIcon>
  )
}

export default Clear2Icon
